export default __webpack_public_path__ + "static/media/arrow-right-large-icon.3f709105.svg";